// extracted by mini-css-extract-plugin
export default {"wrapper":"StoriesTabsHeader_wrapper__1s1LT","content":"StoriesTabsHeader_content__vpSke","link":"StoriesTabsHeader_link__6nzoL","active":"StoriesTabsHeader_active__2E2j0"};